"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POD_PRODUCT_TYPE_LIST = exports.SIZED_PRODUCT_TYPE_LIST = exports.PRODUCT_TYPE = void 0;
const CREW = 'CREW';
const FACE_MASK = 'FACE_MASK';
const EMBROIDERED_BASEBALL_HAT = 'EMBROIDERED_BASEBALL_HAT';
const EMBROIDERED_POLO_SHIRT = 'EMBROIDERED_POLO_SHIRT';
const EXTERNAL_PRODUCT = 'EXTERNAL_PRODUCT';
const HAT = 'HAT';
const HOODIE = 'HOODIE';
const LONG_SLEEVED_SHIRT = 'LONG_SLEEVED_SHIRT';
const MUG = 'MUG';
const POSTER = 'POSTER';
const STICKER = 'STICKER';
const STAINLESS_STEEL_WATER_BOTTLE = 'STAINLESS_STEEL_WATER_BOTTLE';
const SUBSCRIPTION = 'SUBSCRIPTION';
const TOTEBAG = 'TOTEBAG';
const TSHIRT = 'TSHIRT';
const TSHIRT_LEGACY = 'TSHIRT_LEGACY';
exports.PRODUCT_TYPE = {
    CREW,
    FACE_MASK,
    EMBROIDERED_BASEBALL_HAT,
    EMBROIDERED_POLO_SHIRT,
    STICKER,
    STAINLESS_STEEL_WATER_BOTTLE,
    SUBSCRIPTION,
    MUG,
    POSTER,
    TSHIRT_LEGACY,
    TSHIRT,
    HAT,
    HOODIE,
    TOTEBAG,
    EXTERNAL_PRODUCT,
    LONG_SLEEVED_SHIRT
};
exports.SIZED_PRODUCT_TYPE_LIST = [
    exports.PRODUCT_TYPE.CREW,
    exports.PRODUCT_TYPE.HOODIE,
    exports.PRODUCT_TYPE.LONG_SLEEVED_SHIRT,
    exports.PRODUCT_TYPE.EMBROIDERED_POLO_SHIRT,
    exports.PRODUCT_TYPE.TSHIRT
];
exports.POD_PRODUCT_TYPE_LIST = [exports.PRODUCT_TYPE.CREW, exports.PRODUCT_TYPE.HOODIE, exports.PRODUCT_TYPE.LONG_SLEEVED_SHIRT, exports.PRODUCT_TYPE.TSHIRT];
//# sourceMappingURL=productType.js.map